/* eslint-disable epikit/imports */
import * as React from 'react';
import { colorify } from 'lottie-colorify';
import { LottieReact } from '@epihub/web/src/lottie/LottieReact';
import lottieUnderlineJSON from '../assets/raw.noindex/lottie-underline.json';
import lottieBannedJSON from '../assets/raw.noindex/lottie-banned.json';
import lottieCircleJSON from '../assets/raw.noindex/lottie-circle.json';
import JSONDownloadFile from '../assets/raw.noindex/78158-purple-download-file.json';
import JSONTypingMessage from '../assets/raw.noindex/77361-typing-message.json';
import JSONLinkedin from '../assets/raw.noindex/49413-linkedin-icon.json';
import JSONTelegram from '../assets/raw.noindex/49415-telegram-icon.json';
import JSONInstagram from '../assets/raw.noindex/49410-instagram-icon.json';
import JSONTwitter from '../assets/raw.noindex/49409-twitter-icon.json';
import JSONFacebook from '../assets/raw.noindex/49408-facebook-icon.json';
import JSONGithub from '../assets/raw.noindex/81356-github-icon.json';
import JSONMedium from '../assets/raw.noindex/medium-icon.json';
import JSONClose from '../assets/raw.noindex/65846-close-bubble-bottom-sheet.json';

type TWithStyles = {
  className?: string;
  style?: any;
};

type TWithColorableStyles = TWithStyles & {
  color?: Array<string>;
};

export const LottieBanned = ({ className, style, color }: TWithColorableStyles) => {
  const animationData = React.useMemo(() => {
    return color ? colorify(color, lottieBannedJSON) : lottieBannedJSON;
  }, [lottieBannedJSON, color]);
  return <LottieReact loop={false} style={style} className={className} animationData={animationData} />;
};

export const LottieUnderline = ({ className, style, color }: TWithColorableStyles) => {
  const animationData = React.useMemo(() => {
    return color ? colorify(color, lottieUnderlineJSON) : lottieUnderlineJSON;
  }, [lottieUnderlineJSON, color]);
  return <LottieReact loop={false} style={style} className={className} animationData={animationData} />;
};

export const LottieCircle = ({ className, style, color }: TWithColorableStyles) => {
  const animationData = React.useMemo(() => {
    return color ? colorify(color, lottieCircleJSON) : lottieCircleJSON;
  }, [lottieCircleJSON, color]);
  return <LottieReact loop={true} style={style} className={className} animationData={animationData} />;
};

export const LottieClose = ({ className, style, color }: TWithColorableStyles) => {
  const animationData = React.useMemo(() => {
    return color ? colorify(color, JSONClose) : JSONClose;
  }, [JSONClose, color]);
  return <LottieReact loop={false} style={style} className={className} animationData={animationData} />;
};

export const LottieTypingMessage = ({ className, style, color }: TWithColorableStyles) => {
  const animationData = React.useMemo(() => {
    return color ? colorify(color, JSONTypingMessage) : JSONTypingMessage;
  }, [JSONTypingMessage, color]);
  return <LottieReact loop={true} style={style} className={className} animationData={animationData} />;
};

export const LottieDownloadFile = ({ className, style, color }: TWithColorableStyles) => {
  const animationData = React.useMemo(() => {
    return color ? colorify(color, JSONDownloadFile) : JSONDownloadFile;
  }, [JSONDownloadFile, color]);
  return <LottieReact loop={true} style={style} className={className} animationData={animationData} />;
};

export const LottieLinkedin = ({ className, style }: TWithStyles) => {
  return <LottieReact loop={false} style={style} className={className} animationData={JSONLinkedin} />;
};

export const LottieTelegram = ({ className, style }: TWithStyles) => {
  return <LottieReact loop={false} style={style} className={className} animationData={JSONTelegram} />;
};

export const LottieInstagram = ({ className, style }: TWithStyles) => {
  return <LottieReact loop={false} style={style} className={className} animationData={JSONInstagram} />;
};

export const LottieTwitter = ({ className, style }: TWithStyles) => {
  return <LottieReact loop={false} style={style} className={className} animationData={JSONTwitter} />;
};

export const LottieFacebook = ({ className, style }: TWithStyles) => {
  return <LottieReact loop={false} style={style} className={className} animationData={JSONFacebook} />;
};

export const LottieGithub = ({ className, style }: TWithStyles) => {
  return <LottieReact loop={false} style={style} className={className} animationData={JSONGithub} />;
};

export const LottieMedium = ({ className, style }: TWithStyles) => {
  return <LottieReact loop={false} style={style} className={className} animationData={JSONMedium} />;
};
